import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { FiVolume2, FiSquare } from "react-icons/fi";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  const [selectedText, setSelectedText] = useState("");
  const [isReading, setIsReading] = useState(false);
  const synth = window.speechSynthesis;

  useEffect(() => {
    const handleSelection = () => {
      const text = window.getSelection()?.toString().trim();
      setSelectedText(text || "");
    };
    document.addEventListener("mouseup", handleSelection);
    document.addEventListener("keyup", handleSelection);
    return () => {
      document.removeEventListener("mouseup", handleSelection);
      document.removeEventListener("keyup", handleSelection);
    };
  }, []);

  const speakText = () => {
    if (!selectedText || synth.speaking) return;
    const utterance = new SpeechSynthesisUtterance(selectedText);
    utterance.onend = () => setIsReading(false);
    setIsReading(true);
    synth.speak(utterance);
  };

  const stopSpeaking = () => {
    synth.cancel();
    setIsReading(false);
  };

  return (
    <div className="app">
      <Header />
      <main className="app__main">
        <Outlet />
      </main>
      <Footer />

      {(isReading || selectedText) && (
        <button
          className="speak-fab"
          onMouseDown={(e) => e.preventDefault()}
          onClick={isReading ? stopSpeaking : speakText}
        >
          {isReading ? <FiSquare /> : <FiVolume2 />}
          {isReading ? "Stop" : "Read aloud"}
        </button>
      )}
    </div>
  );
};

export default Layout;
